/*
 * @Descripttion: 管网物料调价页面相关方法
 * @Author: 曹博
 * @Date: 2023-10-24 09:11:07
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-01 14:09:14
 */

import { useEffect, useReducer, useRef } from 'react'
import reducer, {
  State,
  initState,
  ProgressItemStatus,
  setCurrentApplyProductMainInfoAction,
  setCurrentStepAction,
  setDataSourceAction,
  setIsDefinitionAction,
  setIsPriceAdjustConfirmBtnLoadingAction,
  setIsPriceAdjustmentModalOpenAction,
  setLoadingAction,
  setPagesAction,
  setProgressListAction,
  setSearchDataAction,
  setSubmitApplyFlagAction,
  setHasRulesAction,
} from './reducer'
import { Form, RadioChangeEvent, message } from 'antd'
import {
  APPLY_FOR_PRICE_ADJUSTMENT,
  AdjustPriceParams,
  GET_GW_PLATFORM_PRODUCT_PAGE,
  GET_GW_PLATFORM_PRODUCT_PERMISSION,
  GwProductItem,
} from '../../api/InventoryManagementApi'
import { history } from '../../redux/store'
import { userRouter } from '../../route'
import { isResponseCodeSuccess } from '../../tools/util'
import copy from 'copy-to-clipboard'

const UseMaterialPriceAdjustmentHooks = () => {
  const timer = useRef<boolean>()
  const [state, dispatch] = useReducer(reducer, initState)
  const { progressList, currentApplyProductMainInfo } = state
  const [form] = Form.useForm()
  const supRoute = userRouter[1].url
  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchDataAction(params))
    purviewCheck({
      ...state,
      ...{
        searchData: params,
      },
    })
  }

  // 切换分页
  const handlePaginationChange = (current: number, pagesize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: current,
        pageSize: pagesize,
      }),
    )
    purviewCheck({
      ...state,
      ...{
        pages: {
          pageNo: current,
          pageSize: pagesize ? pagesize : 10,
        },
      },
    })
  }

  // 刷新
  const onRefresh = () => {
    purviewCheck(state)
  }

  // 获取物料列表
  const getData = async (state: State) => {
    dispatch(setLoadingAction(true))
    const params = { ...state.pages, ...state.searchData }
    const res = await GET_GW_PLATFORM_PRODUCT_PAGE({ ...params })
    dispatch(setLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      dispatch(
        setDataSourceAction({
          dataSource: {
            data: res.data.content,
            total: res.data.totalCount,
          },
          pageNo: res.data.pageNo,
        }),
      )
    }
  }

  // 控制调价弹窗显隐
  const changePriceAdjustmentModalVis = (val: boolean, record: any) => {
    // 打开弹窗
    if (val) {
      dispatch(
        setCurrentApplyProductMainInfoAction({
          id: record.id,
          code: record.code,
          name: record.name,
          brandName: record.brandName,
          manuCode: record.manuCode,
          gwProductSerialNumber: record.gwProductSerialNumber,
          orderRate: record.orderRate,
          highestChangePrice: record.highestChangePrice,
        }),
      )
    } else {
      timer.current = false
      // 关闭弹窗时清空表单数据，并隐藏自定义输入框
      form.resetFields()
      dispatch(setIsDefinitionAction(false))
      dispatch(setSubmitApplyFlagAction(false))
      // 重置进度条数据
      changeProgressList('loading', 0)
    }
    dispatch(setIsPriceAdjustConfirmBtnLoadingAction(false))
    dispatch(setIsPriceAdjustmentModalOpenAction(val))
  }

  // 根据所选调价类型判断是否展示金额及备注的输入框
  const onAdjustPriceTypeChange = (e: RadioChangeEvent) => {
    // 选择自定义调价时，展示输入框
    if (e.target.value === '3') {
      dispatch(setIsDefinitionAction(true))
    } else {
      dispatch(setIsDefinitionAction(false))
    }
  }

  // 提交物料调价
  const cofirmPriceAdjustment = async () => {
    const formValue = await form.validateFields()
    const adjustedFormValue = { ...formValue, adjustType: 3 } // 本次版本暂时写死
    dispatch(setIsPriceAdjustConfirmBtnLoadingAction(true))
    applyForPriceAdjustment(adjustedFormValue)

    // // 当前选中的调价类型为自定义时，不需要调用查询价格等接口，直接调用调价申请接口即可
    // if (formValue.adjustType === '3') {
    //   applyForPriceAdjustment(formValue)
    // } else {
    //   // 调价类型非自定义时，弹窗展示步骤条并依次调用接口获取数据，当关闭页面时取消后续接口调用
    //   dispatch(setSubmitApplyFlagAction(true))
    //   timer.current = true
    //   // 1、唤醒机器人并获取价格参数
    //   rouseRobot(formValue)
    // }
  }

  // 唤醒机器人并获取价格
  // const rouseRobot = async (val: any) => {
  //   const res = await ROUSE_ROBOT({
  //     gwProductSerialNumber: currentApplyProductMainInfo.gwProductSerialNumber,
  //   })
  //   if (isResponseCodeSuccess(res.code)) {
  //     // 获取价格
  //     getBottomPrice(res.data, val)
  //   } else {
  //     // 接口调用失败，修改步骤条内容
  //     changeProgressList('error', 0)
  //   }
  // }

  // 获取价格
  // const getBottomPrice = async (id: string, val: any) => {
  //   if (timer.current) {
  //     const taskId = id
  //     const res = await QUERY_ROBOT_EXECUTION_RESULT({
  //       taskId,
  //       gwProductSerialNumber:
  //         currentApplyProductMainInfo.gwProductSerialNumber,
  //     })
  //     if (isResponseCodeSuccess(res.code)) {
  //       if (res.data && timer.current) {
  //         // 获取到价格数据后，当前步骤条为第二步，调用接口保存价格参数
  //         // 修改第二步步骤条状态
  //         changeProgressList('loading', 1)
  //         // 2、保存价格参数
  //         const addPriceRes = await ADD_GW_BOTTOM_PRICE({
  //           price: res.data,
  //           code: currentApplyProductMainInfo.code,
  //         })
  //         if (addPriceRes.code === 0) {
  //           // 3、提交调价申请，提交成功后关闭页面
  //           changeProgressList('loading', 2)
  //           applyForPriceAdjustment(val)
  //         } else {
  //           changeProgressList('error', 1)
  //         }
  //         // 当前接口未获取到价格数据，再次调用
  //       } else if (timer.current) {
  //         setTimeout(() => {
  //           getBottomPrice(taskId, val)
  //         }, 5000)
  //       }
  //     } else {
  //       timer.current = false
  //       changeProgressList('error', 0)
  //     }
  //   }
  // }

  // 提交调价申请
  const applyForPriceAdjustment = async (val: any) => {
    const param: AdjustPriceParams = {
      adjustType: val.adjustType,
      code: currentApplyProductMainInfo.code,
      id: currentApplyProductMainInfo.id,
    }
    // 自定义调价时，保存调价金额及备注
    param.adjustPrice = val.adjustPrice
    param.remark = val.remark
    const res = await APPLY_FOR_PRICE_ADJUSTMENT({ ...param })
    if (isResponseCodeSuccess(res.code)) {
      changePriceAdjustmentModalVis(false, {})
      message.success('您的调价申请已成功提交，等待审核通过即可')
      purviewCheck(state)
    } else {
      dispatch(setIsPriceAdjustConfirmBtnLoadingAction(false))
      // 接口调用失败 取消提交按钮的loading状态并修改步骤条状态
      // if (val.adjustType === '3') {
      //   dispatch(setIsPriceAdjustConfirmBtnLoadingAction(false))
      // }
      // changeProgressList('error', 2)
    }
  }

  // 点击物料
  const onhandlDetail = (record: GwProductItem) => {
    history.replace({
      pathname: `${supRoute}/editgoods`,
      state: {
        tempCode: record.code,
        BtnState: ['Edit'],
      },
    })
  }

  // 修改进度条数据
  const changeProgressList = (
    state: ProgressItemStatus,
    targetIndex: number,
  ) => {
    dispatch(setCurrentStepAction(targetIndex))
    const list = progressList.map((item, index) => ({
      title: item.title,
      // 修改指定步骤的状态
      status: index === targetIndex ? state : '',
    }))
    dispatch(setProgressListAction(list))
  }

  useEffect(() => {
    purviewCheck(state)
  }, [])

  const purviewCheck = async (state: State) => {
    const res = await GET_GW_PLATFORM_PRODUCT_PERMISSION()
    if (isResponseCodeSuccess(res.code)) {
      if (res.data) {
        dispatch(setHasRulesAction(res.data))
        getData(state)
      } else {
        dispatch(setLoadingAction(false))
      }
    }
  }

  const onCopy = (record: any) => {
    copy(record)
    message.success('复制成功')
  }
  return {
    hookstate: state,
    form,
    handleSearchClick,
    onRefresh,
    handlePaginationChange,
    changePriceAdjustmentModalVis,
    cofirmPriceAdjustment,
    onAdjustPriceTypeChange,
    onhandlDetail,
    onCopy,
  }
}

export default UseMaterialPriceAdjustmentHooks
/*
 * @Descripttion: 管网物料调价页面相关方法
 * @Author: 曹博
 * @Date: 2023-10-24 09:11:07
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-01 14:09:14
 */

import { useEffect, useReducer, useRef } from 'react'
import reducer, {
  State,
  initState,
  ProgressItemStatus,
  setCurrentApplyProductMainInfoAction,
  setCurrentStepAction,
  setDataSourceAction,
  setIsDefinitionAction,
  setIsPriceAdjustConfirmBtnLoadingAction,
  setIsPriceAdjustmentModalOpenAction,
  setLoadingAction,
  setPagesAction,
  setProgressListAction,
  setSearchDataAction,
  setSubmitApplyFlagAction,
  setHasRulesAction,
} from './reducer'
import { Form, RadioChangeEvent, message } from 'antd'
import {
  APPLY_FOR_PRICE_ADJUSTMENT,
  AdjustPriceParams,
  GET_GW_PLATFORM_PRODUCT_PAGE,
  GET_GW_PLATFORM_PRODUCT_PERMISSION,
  GwProductItem,
} from '../../api/InventoryManagementApi'
import { history } from '../../redux/store'
import { userRouter } from '../../route'
import { isResponseCodeSuccess } from '../../tools/util'
import copy from 'copy-to-clipboard'

const UseMaterialPriceAdjustmentHooks = () => {
  const timer = useRef<boolean>()
  const [state, dispatch] = useReducer(reducer, initState)
  const { progressList, currentApplyProductMainInfo } = state
  const [form] = Form.useForm()
  const supRoute = userRouter[1].url
  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchDataAction(params))
    purviewCheck({
      ...state,
      ...{
        searchData: params,
      },
    })
  }

  // 切换分页
  const handlePaginationChange = (current: number, pagesize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: current,
        pageSize: pagesize,
      }),
    )
    purviewCheck({
      ...state,
      ...{
        pages: {
          pageNo: current,
          pageSize: pagesize ? pagesize : 10,
        },
      },
    })
  }

  // 刷新
  const onRefresh = () => {
    purviewCheck(state)
  }

  // 获取物料列表
  const getData = async (state: State) => {
    dispatch(setLoadingAction(true))
    const params = { ...state.pages, ...state.searchData }
    const res = await GET_GW_PLATFORM_PRODUCT_PAGE({ ...params })
    dispatch(setLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      dispatch(
        setDataSourceAction({
          dataSource: {
            data: res.data.content,
            total: res.data.totalCount,
          },
          pageNo: res.data.pageNo,
        }),
      )
    }
  }

  // 控制调价弹窗显隐
  const changePriceAdjustmentModalVis = (val: boolean, record: any) => {
    // 打开弹窗
    if (val) {
      dispatch(
        setCurrentApplyProductMainInfoAction({
          id: record.id,
          code: record.code,
          name: record.name,
          brandName: record.brandName,
          manuCode: record.manuCode,
          gwProductSerialNumber: record.gwProductSerialNumber,
          orderRate: record.orderRate,
          highestChangePrice: record.highestChangePrice,
        }),
      )
    } else {
      timer.current = false
      // 关闭弹窗时清空表单数据，并隐藏自定义输入框
      form.resetFields()
      dispatch(setIsDefinitionAction(false))
      dispatch(setSubmitApplyFlagAction(false))
      // 重置进度条数据
      changeProgressList('loading', 0)
    }
    dispatch(setIsPriceAdjustConfirmBtnLoadingAction(false))
    dispatch(setIsPriceAdjustmentModalOpenAction(val))
  }

  // 根据所选调价类型判断是否展示金额及备注的输入框
  const onAdjustPriceTypeChange = (e: RadioChangeEvent) => {
    // 选择自定义调价时，展示输入框
    if (e.target.value === '3') {
      dispatch(setIsDefinitionAction(true))
    } else {
      dispatch(setIsDefinitionAction(false))
    }
  }

  // 提交物料调价
  const cofirmPriceAdjustment = async () => {
    const formValue = await form.validateFields()
    const adjustedFormValue = { ...formValue, adjustType: 3 } // 本次版本暂时写死
    dispatch(setIsPriceAdjustConfirmBtnLoadingAction(true))
    applyForPriceAdjustment(adjustedFormValue)

    // // 当前选中的调价类型为自定义时，不需要调用查询价格等接口，直接调用调价申请接口即可
    // if (formValue.adjustType === '3') {
    //   applyForPriceAdjustment(formValue)
    // } else {
    //   // 调价类型非自定义时，弹窗展示步骤条并依次调用接口获取数据，当关闭页面时取消后续接口调用
    //   dispatch(setSubmitApplyFlagAction(true))
    //   timer.current = true
    //   // 1、唤醒机器人并获取价格参数
    //   rouseRobot(formValue)
    // }
  }

  // 唤醒机器人并获取价格
  // const rouseRobot = async (val: any) => {
  //   const res = await ROUSE_ROBOT({
  //     gwProductSerialNumber: currentApplyProductMainInfo.gwProductSerialNumber,
  //   })
  //   if (isResponseCodeSuccess(res.code)) {
  //     // 获取价格
  //     getBottomPrice(res.data, val)
  //   } else {
  //     // 接口调用失败，修改步骤条内容
  //     changeProgressList('error', 0)
  //   }
  // }

  // 获取价格
  // const getBottomPrice = async (id: string, val: any) => {
  //   if (timer.current) {
  //     const taskId = id
  //     const res = await QUERY_ROBOT_EXECUTION_RESULT({
  //       taskId,
  //       gwProductSerialNumber:
  //         currentApplyProductMainInfo.gwProductSerialNumber,
  //     })
  //     if (isResponseCodeSuccess(res.code)) {
  //       if (res.data && timer.current) {
  //         // 获取到价格数据后，当前步骤条为第二步，调用接口保存价格参数
  //         // 修改第二步步骤条状态
  //         changeProgressList('loading', 1)
  //         // 2、保存价格参数
  //         const addPriceRes = await ADD_GW_BOTTOM_PRICE({
  //           price: res.data,
  //           code: currentApplyProductMainInfo.code,
  //         })
  //         if (addPriceRes.code === 0) {
  //           // 3、提交调价申请，提交成功后关闭页面
  //           changeProgressList('loading', 2)
  //           applyForPriceAdjustment(val)
  //         } else {
  //           changeProgressList('error', 1)
  //         }
  //         // 当前接口未获取到价格数据，再次调用
  //       } else if (timer.current) {
  //         setTimeout(() => {
  //           getBottomPrice(taskId, val)
  //         }, 5000)
  //       }
  //     } else {
  //       timer.current = false
  //       changeProgressList('error', 0)
  //     }
  //   }
  // }

  // 提交调价申请
  const applyForPriceAdjustment = async (val: any) => {
    const param: AdjustPriceParams = {
      adjustType: val.adjustType,
      code: currentApplyProductMainInfo.code,
      id: currentApplyProductMainInfo.id,
    }
    // 自定义调价时，保存调价金额及备注
    param.adjustPrice = val.adjustPrice
    param.remark = val.remark
    const res = await APPLY_FOR_PRICE_ADJUSTMENT({ ...param })
    if (isResponseCodeSuccess(res.code)) {
      changePriceAdjustmentModalVis(false, {})
      message.success('您的调价申请已成功提交，等待审核通过即可')
      purviewCheck(state)
    } else {
      dispatch(setIsPriceAdjustConfirmBtnLoadingAction(false))
      // 接口调用失败 取消提交按钮的loading状态并修改步骤条状态
      // if (val.adjustType === '3') {
      //   dispatch(setIsPriceAdjustConfirmBtnLoadingAction(false))
      // }
      // changeProgressList('error', 2)
    }
  }

  // 点击物料
  const onhandlDetail = (record: GwProductItem) => {
    history.replace({
      pathname: `${supRoute}/editgoods`,
      state: {
        tempCode: record.code,
        BtnState: ['Edit'],
      },
    })
  }

  // 修改进度条数据
  const changeProgressList = (
    state: ProgressItemStatus,
    targetIndex: number,
  ) => {
    dispatch(setCurrentStepAction(targetIndex))
    const list = progressList.map((item, index) => ({
      title: item.title,
      // 修改指定步骤的状态
      status: index === targetIndex ? state : '',
    }))
    dispatch(setProgressListAction(list))
  }

  useEffect(() => {
    purviewCheck(state)
  }, [])

  const purviewCheck = async (state: State) => {
    const res = await GET_GW_PLATFORM_PRODUCT_PERMISSION()
    if (isResponseCodeSuccess(res.code)) {
      if (res.data) {
        dispatch(setHasRulesAction(res.data))
        getData(state)
      } else {
        dispatch(setLoadingAction(false))
      }
    }
  }

  const onCopy = (record: any) => {
    copy(record)
    message.success('复制成功')
  }
  return {
    hookstate: state,
    form,
    handleSearchClick,
    onRefresh,
    handlePaginationChange,
    changePriceAdjustmentModalVis,
    cofirmPriceAdjustment,
    onAdjustPriceTypeChange,
    onhandlDetail,
    onCopy,
  }
}

export default UseMaterialPriceAdjustmentHooks
